import Avatar from "material-ui/Avatar";
import React, { Component } from "react";
import "./introduction.css";

class IntroductionComponent extends Component {
  render() {
    return (
      <div className="introduction">
        <Avatar src="avatar.jpeg" size={150} />
        <p className="introduction-text">
          Loves Python, ReactJS, and dogs. Professional IceCream-Eater. Marvel
          Cinematic Universe Fan. Ex Industry Analyst for the Pharmaceutical
          Industry and aspiring Data Scientist, currently living in Melbourne,
          Australia.
        </p>
      </div>
    );
  }
}

export default IntroductionComponent;
